import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Collapse } from "antd";
import { userPermissionFilter } from "../../../swzutils/UserPermissionsUtil";
import { conditionFilter } from "../../../swzutils";
import { loggedInUserSelector } from "../../../store/slice/auth";
import { useAppSelector } from "../../../store";
export const PermissionCollapse = ({ items }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const visibleItems = items
        .filter(item => userPermissionFilter(loggedInUser, item))
        .filter(conditionFilter)
        // strip our custom props so antd doesn't forward them to the DOM
        .map(({ condition, permissions, ...item }) => item);
    return (_jsx(Collapse, { items: visibleItems }));
};
